import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/repo/node_modules/.pnpm/next@15.5.15_@opentelemetry+api@1.9.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/app-dir/link.js");
